import React from "react";
import star from "../images/star.svg";
import { useStateValue } from "../StateProvider";
import "../styles/ItemsInBasket.css";
import { motion } from "framer-motion";

function ItemsInBasket({ item }) {
  const [{ basket }, dispatch] = useStateValue();

  const removeFromBasket = () => {
    dispatch({
      type: "REMOVE_FROM_BASKET",
      item: item,
    });
  };

  return (
    <div className="basket_items" exit={{ y: -1000, animationDelay: 2 }}>
      <img src={item.image} alt="" className="basket__img" />
      <div className="basket__info">
        <p className="basket_title">{item.title}</p>

        <strong className="basket__price">
          <small>$</small> {item.price}
        </strong>
        <span className="basket__rating">
          {Array(item.rating).fill(<img src={star} alt="" width="20" />)}
        </span>
        <motion.button
          className="basket__btn"
          onClick={removeFromBasket}
          whileHover={{ x: [0, 20, 0, 20, 0, 20, 0] }}
        >
          Remove from Basket
        </motion.button>
      </div>
    </div>
  );
}

export default ItemsInBasket;
